import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="site-footer-brand">
          <div className="site-footer-logo">Kno U Kno</div>
          <p>
            AI writes the business-start questions. You write the answers. Answers are saved in MongoDB and
            organized one page at a time.
          </p>
        </div>

        <div className="site-footer-section">
          <h3>Access</h3>
          <p>Free: questions 1 to 5</p>
          <p>Members: questions 1 to 50, bonus through 150</p>
          <p>Pro: questions 1 to 75, bonus through 175</p>
        </div>

        <div className="site-footer-section">
          <h3>Navigate</h3>
          <div className="site-footer-links">
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/price">Pricing</Link>
            <Link to="/register">Register</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
